<template>
  <div class="flex items-center justify-between gap-4" data-testid="header-free-uploads-banner">
    <span class="hidden sm:inline-block">
      <Button type="solid" variant="orange" href="/plans?utm_campaign=upgrade&utm_medium=button&utm_source=viewer" data-testid="viewer-header-upgrade-button"
        >Upgrade</Button
      >
    </span>
    <a
      href="/plans?utm_campaign=upgrade&utm_medium=button&utm_source=viewer"
      class="flex sm:hidden flex-col h-9 mr-2 px-2 py-0.5 border border-transparent rounded-10 outline-none focus-visible:ring select-none text-white bg-gradient-to-tr from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 focus-visible:ring-red-500/50"
    >
      <span class="text-sm font-bold">Upgrade</span>
      <span data-testid="hard-limit-counter-mobile" class="-mt-1 text-xs">UPLOADS: {{ itemCount }}/{{ dropLimit }}</span>
    </a>
    <div class="hidden sm:block text-sm text-slate-400 dark:text-zinc-600">
      <div class="uppercase block md:inline">
        <span class="hidden md:inline">Free </span>
        <span>uploads:</span>
      </div>
      <span data-testid="hard-limit-counter" class="font-semibold text-amber-600"> {{ itemCount }}/{{ dropLimit }}</span>
      <div class="h-0.5 mt-1 rounded bg-slate-200 dark:bg-zinc-800 relative">
        <div class="absolute top-0 left-0 h-full bg-amber-600" :style="{ width: itemCapacityPercent + '%' }"></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/useUserStore';
import { Button } from '@/storybook/button';

const { itemCount, itemCapacityPercent, dropLimit } = storeToRefs(useUserStore());
</script>
